import { Button } from '@/common/ui/button'
import type { components } from '@/schema'
import type { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Link } from 'react-router-dom'

type PlayerGameStatsItem = components['schemas']['PlayerGameStatsItemResponse']

export const playerGameStatsColumns: ColumnDef<PlayerGameStatsItem>[] = [
	{
		id: 'playerInfo',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			return (
				<div className="space-y-1">
					<p>{row.original.playerPhone || '-'}</p>
					<p className="text-xs text-muted-foreground">
						ชื่อ: {row.original.playerName || '-'}
					</p>
					<p className="text-xs text-muted-foreground">
						playerId: {row.original.playerId || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'gameName',
		header: 'เกม/ผู้ให้บริการ',
		cell: ({ row }) => {
			const displayName = row.original.gameDisplayName || row.original.gameName
			return (
				<div className="space-y-1">
					<p>{displayName || '-'}</p>
					<p className="text-xs text-muted-foreground">
						ผู้ให้บริการ: {row.original.provider || '-'}
					</p>
					<p className="text-xs text-muted-foreground">
						ประเภท: {row.original.gameType || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalPlayCount',
		header: 'สถิติรวม',
		cell: ({ row }) => {
			const profit = row.original.totalProfit
			const isProfit = profit > 0
			return (
				<div className="space-y-1 text-left text-sm">
					<p>
						จำนวนเล่น:{' '}
						{new Intl.NumberFormat('th-TH').format(row.original.totalPlayCount)}
					</p>
					<p>
						เดิมพันรวม:{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(row.original.totalBetAmount)}
					</p>
					<p>
						Turnover:{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(row.original.totalTurnover)}
					</p>
					<p
						className={
							isProfit
								? 'font-medium text-red-600'
								: 'font-medium text-green-600'
						}
					>
						กำไร/ขาดทุน: {isProfit ? '+' : ''}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(profit)}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalTransferIn',
		header: 'โอน/เวลา',
		cell: ({ row }) => {
			return (
				<div className="space-y-1 text-left text-sm">
					<p>
						โอนเข้า / ออก:{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(row.original.totalTransferIn)}{' '}
						/{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(row.original.totalTransferOut)}
					</p>
					<p className="text-xs text-muted-foreground">
						เล่นล่าสุด:{' '}
						{(() => {
							const lastPlayAt = row.original.lastPlayAt
							if (
								typeof lastPlayAt !== 'string' &&
								typeof lastPlayAt !== 'number'
							) {
								return '-'
							}
							return format(new Date(lastPlayAt), 'dd MMM yyyy HH:mm:ss', {
								locale: th,
							})
						})()}
					</p>
				</div>
			)
		},
	},
	{
		id: 'actions',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<div>
				<Button asChild variant="outline" size="sm">
					<Link
						to={`/operator/get-player-list/player-detail/${row.original.playerId}`}
					>
						ดูข้อมูลผู้เล่น
					</Link>
				</Button>
			</div>
		),
	},
]
